import React from 'react'
import PropTypes from 'prop-types';
import Dialog from 'components/Dialog';
import Tr from 'translations/Translations';
import SelectOrganizationForm from "./SelectOrganizationForm";

function SelectOrganization(
    {
        open,
        onConfirm,
        onCancel,
        initOrganization,
        availableOrganizations,
        title = 'organizational_unit'
    }) {

    return (<Dialog
        titleCentered
        title={Tr(title)}
        open={open}
        maxWidth={'sm'}
        onClose={onCancel}>
        <SelectOrganizationForm
            onSubmit={onConfirm}
            onCancel={onCancel}
            initOrganization={initOrganization}
            availableOrganizations={availableOrganizations}
        />
    </Dialog>)
}

SelectOrganization.propTypes = {
    classes: PropTypes.any,
}

export default SelectOrganization;